<script>
import Button from 'element-ui/lib/button';

export default Button;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/button.css';
// @import "../../stylesheets/element-theme/button-group.css";
@import '../../stylesheets/utils/utils';
// Adding RTL support to element's buttons

.el-button {
  .material-icons {
    font-size: 1em;
    vertical-align: middle;
  }

  [class*='el-icon-'] {
    vertical-align: middle;
  }

  &--text {
    &:hover {
      border-color: transparent !important;
    }
  }

  @include rtl() {
    // space between adjacent buttons
    /* stylelint-disable-next-line */
    & + .el-button {
      margin-left: 0;
      margin-right: 10px;
    }

    // space between button text and icon
    [class*='el-icon-'] + span {
      margin-left: auto;
      margin-right: 5px;
    }
  }

  &--reverse-icon {
    direction: rtl;

    @include rtl() {
      direction: ltr;
    }

    [class*='el-icon-'] + span {
      margin-left: 0;
      margin-right: 5px;

      @include rtl() {
        margin-left: 5px;
        margin-right: 0;
      }
    }
  }
}
</style>
